import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import ShareButton from '../components/ShareButton';
import SubjectPicker from '../components/SubjectPicker';

// Les QCM publiés d'un sujet
export default function QcmSubject() {
  const { id } = useParams();
  const [subject, setSubject] = useState(null);
  const [all, setAll] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    fetch('/api/qcm/subjects')
      .then(r => r.ok ? r.json() : Promise.reject(new Error('Chargement impossible.')))
      .then(list => {
        const s = list.find(x => x.id === Number(id));
        if (!s) throw new Error('Ce sujet n\'existe pas ou ne contient pas encore de QCM.');
        setAll(list.map(x => ({ id: x.id, name: x.name, count: x.quizzes.length })));
        setSubject(s);
      })
      .catch(e => setError(e.message || 'Chargement impossible.'));
  }, [id]);

  if (error) return <section className="section"><Link to="/qcm" className="qcm-back">← tous les sujets</Link><div className="empty-state">{error}</div></section>;
  if (!subject) return <section className="section"><div className="empty-state">chargement...</div></section>;

  return (
    <section className="section fade-in">
      <Link to="/qcm" className="qcm-back">← tous les sujets</Link>
      <div className="section-head">
        <h2>{subject.name}</h2>
        <span className="head-right">
          <span className="counter">{String(subject.quizzes.length).padStart(2, '0')} QCM</span>
          <ShareButton variant="icon" title={`QCM — ${subject.name}`} text={`Testez-vous : les QCM « ${subject.name} » sur Zahra's Learning`} />
        </span>
      </div>
      <SubjectPicker subjects={all} current={subject.id} allHref="/qcm" hrefFor={sid => `/qcm/sujet/${sid}`} unit="QCM" />
      {subject.description && <p className="qcm-subject-desc">{subject.description}</p>}
      <div className="articles-grid">
        {subject.quizzes.map(q => (
          <Link key={q.id} to={`/qcm/${q.id}`} className="card qcm-card">
            <div className="card-date">
              <span>{q.question_count} question{q.question_count > 1 ? 's' : ''}</span>
              <span className={`qcm-timer-badge ${q.timer_enabled ? 'on' : ''}`}>
                {q.timer_enabled ? `⏱ ${q.timer_minutes} min` : 'sans timer'}
              </span>
            </div>
            <h3>{q.title}</h3>
            {q.description && <p className="card-excerpt">{q.description}</p>}
            <span className="qcm-card-go">commencer →</span>
          </Link>
        ))}
      </div>
    </section>
  );
}
